export default __webpack_public_path__ + "static/media/target-12@2x.69605a34.png";